import { render, staticRenderFns } from "./ReportGallery.vue?vue&type=template&id=bec25718&scoped=true&lang=pug&"
import script from "./ReportGallery.vue?vue&type=script&lang=ts&"
export * from "./ReportGallery.vue?vue&type=script&lang=ts&"
import style0 from "./ReportGallery.vue?vue&type=style&index=0&id=bec25718&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec25718",
  null
  
)

export default component.exports